
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachNavigationVue from "@/components/coach/navigation.vue";
import CoachPlayersProfileNavigationVue from "@/components/coach/players/profile/navigation.vue";
import CoachPlayersProfileTrainingsFilterIndexVue from "@/views/app/coach/players/profile/trainings/filter/index.vue";
import CoachPlayersProfileTrainingsListIndexVue from "@/views/app/coach/players/profile/trainings/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    CoachNavigationVue,
    CoachPlayersProfileNavigationVue,
    CoachPlayersProfileTrainingsFilterIndexVue,
    CoachPlayersProfileTrainingsListIndexVue
  },
})
export default class CoachPlayersProfileTrainingsIndexVue extends Vue {
  isLoading: boolean | null = false;

  trainingCategories: Array<AppCommonTrainingCategory> = [];

  $refs!: {
    CoachPlayersProfileTrainingsListIndexVue: any;
  };

  getTrainingsByFilter(formData): void {
    this.$refs.CoachPlayersProfileTrainingsListIndexVue.getTrainings(formData);
  }

  async getTrainingCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/training-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainingCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getTrainingCategories();
  }
}
